/**
 * @generated SignedSource<<a30268f074c2c89a57abfc31793e8550>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RegenerateForLanguageModalFragment_meetingRecording$data = {
  readonly canRegenerateSummary: boolean;
  readonly detectedLanguage: string | null;
  readonly id: string;
  readonly languageConfidenceScore: number | null;
  readonly regenerationForLanguageIsInProgress: boolean;
  readonly " $fragmentType": "RegenerateForLanguageModalFragment_meetingRecording";
};
export type RegenerateForLanguageModalFragment_meetingRecording$key = {
  readonly " $data"?: RegenerateForLanguageModalFragment_meetingRecording$data;
  readonly " $fragmentSpreads": FragmentRefs<"RegenerateForLanguageModalFragment_meetingRecording">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RegenerateForLanguageModalFragment_meetingRecording",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "detectedLanguage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "languageConfidenceScore",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canRegenerateSummary",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "regenerationForLanguageIsInProgress",
      "storageKey": null
    }
  ],
  "type": "MeetingRecording",
  "abstractKey": null
};

(node as any).hash = "caaffafc4447e93179d5fbf6799c180d";

export default node;
